export enum IdentificadorMensajesEnum {
  disclaimer = "disclaimer",
  parcialidades = "parcialidades",
  notificación = "notificación",
  seguros = "seguros",
  apoyos = "apoyos",
  aportación = "aportación",
}
